import type { SeparationQuestion, SeparationSubItem } from './separation.types'

export const transactionIdsFor = (subItem: SeparationSubItem): number[] =>
  subItem.transactionIds ??
  (Number.isInteger(Number(subItem.id)) ? [Number(subItem.id)] : [])

/**
 * The transactions a question stands for. A question's own `id` is its merchant lookup key,
 * which two accounts can share, so identity for queueing purposes has to come from the rows.
 */
export const transactionIdsOf = (question: SeparationQuestion): number[] =>
  question.subItems.flatMap(transactionIdsFor)
